import type { VisitorType } from '@/shared/types/store.types'

export const isYoungerThan23 = (birthDate: Date | string) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const birth = new Date(birthDate)
  birth.setHours(0, 0, 0, 0)

  const date23YearsAgo = new Date(today.getFullYear() - 23, today.getMonth(), today.getDate())
  date23YearsAgo.setHours(0, 0, 0, 0)

  return birth > date23YearsAgo
}

export const lastFour = (passport: string) => passport.slice(-4)

export const formatHolderFullName = (visitor: { firstName: string; lastName: string }) =>
  `${visitor.firstName} ${visitor.lastName}`

export const collectHoldersPass = (visitors: VisitorType[]) =>
  visitors.map((v) => lastFour(v.passport))
